import { render, staticRenderFns } from "./videoDetails.vue?vue&type=template&id=d6d5dfc2&scoped=true"
import script from "./videoDetails.vue?vue&type=script&lang=js"
export * from "./videoDetails.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/videoDetails.css?vue&type=style&index=0&id=d6d5dfc2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d5dfc2",
  null
  
)

export default component.exports